export class PartCategory {
    partCategoryID: number;
    partCategoryDesc: string;
    imageUrl: string;
  isActive: boolean;
  indexOrderID: number;
  image: ByteString;
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/partcategory/partcategory.model.ts